// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"188":"p__OceanBaseWithFlink__index","532":"p__Order","729":"p__Layout__index","770":"p__Layout__BasicLayout__index"}[chunkId] + ".chunk.css";
};